import { Tag } from '#/shared/ui/tag'
import type { TagProps } from '#/shared/ui/tag'

interface SourceCellProps {
  label: string
  variant?: TagProps['variant']
}

export function SourceCell({ label, variant }: SourceCellProps) {
  return (
    <div className="flex flex-col items-start">
      <div className="flex h-7 items-center">
        <Tag variant={variant}>{label}</Tag>
      </div>
      <div className="h-7" />
    </div>
  )
}
